import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of, tap } from "rxjs";
import { addSuccessUserCompanyAct, addUserCompanyAct, setViolationsUserCompanyAct, showMsgErrorAct } from "./companies-user-actions";
import { CompanyService } from "../../services/company.service";
import { AlertaService } from "../../services/alerta.service";

@Injectable()
export class CompaniesUserEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private companyService = inject(CompanyService);
    private alerta = inject(AlertaService);

    addUserCompanyEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(addUserCompanyAct),
            exhaustMap(action => this.companyService.createUserCompany(action.id, action.userNew)
                .pipe(
                    map(userNew => addSuccessUserCompanyAct({ userNew })),
                    //catchError(error => (error.status == 400) ? of(setViolationsUserAct({ userForm: action.userNew, violations: this.violationsToObject(error.error.violations) })) : of(showMsgErrorAct({ error }))
                    catchError(error => {
                        if(error.status == 400) {
                            return of(setViolationsUserCompanyAct({ userForm: action.userNew, violations: this.violationsToObject(error.error.parameterViolations)})) ;
                            }else {
                            return of(showMsgErrorAct({ error }));
                            }
                    }
                    )
                )
            )
        )
    );
    addSuccessUserCompanyEffect$ = createEffect(() => this.actions$.pipe(
        ofType(addSuccessUserCompanyAct),
        tap(() => {
            //this.router.navigate(['/users']);

            this.alerta.correct('Usuario creado con exito!', () => {
                window.location.reload();
            });
        })
    ), { dispatch: false });

    showMsgErrorEffect$ = createEffect(() => this.actions$.pipe(
        ofType(showMsgErrorAct),
        tap((action) => {
            
            this.alerta.error("Se ha precentado un error interno");
        })
    ), { dispatch: false });    

    violationsToObject(violationsList: []): any {
        return violationsList.reduce((obj: { [x: string]: any; }, item: { path: string; message: any; }) => {
            //obj[item.field.slice(item.field.lastIndexOf('.') + 1)] = item.message;
            //obj[item.field.slice(item.field.indexOf('.') + 1).replaceAll('.', '_')] = item.message;
            obj[item.path.slice(item.path.indexOf('.') + 1)] = item.message;
            return obj;
        }, {});
    };
}